exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-checkbox[data-v-2fe1cf41]{margin-right:15px}.el-checkbox+.el-checkbox[data-v-2fe1cf41]{margin-left:0}.el-checkbox__label[data-v-2fe1cf41]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fe1cf41","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/ht/HtCheckbox.vue
// module id = 219
// module chunks = 0